import { push } from 'connected-react-router';
import { call, put, select, takeLatest } from 'redux-saga/effects';

// Services
import { companyUsersApi } from 'services/apiDigitalTicket/companyUsers';

// Actions
import * as DialogsActions from 'store/ducks/dialogs/actions';
import * as SnackbarsActions from 'store/ducks/snackbars/actions';
import * as CompanyUsersActions from './actions';

// Constants
import ENVIRONMENTS from 'constants/enviroments';
import COMPANNIES from 'constants/companies';
import { errorMessagersList } from 'helpers/errorMessagers';

// Types
import { CompanyUsersTypes } from './types';

function* check({
  payload,
}: ReturnType<typeof CompanyUsersActions.checkCompanyUsersRequest>): any {
  try {
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );
    const response = yield call(companyUsersApi.check, {
      data: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        CompanyUsersActions.checkCompanyUsersSuccess({
          checkCompanyUsersList: response.data,
        }),
      );
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('company Users - Check Users - error', error);
    yield put(
      SnackbarsActions.setOpen({
        message,
        open: true,
        type: 'error',
      }),
    );
    yield put(CompanyUsersActions.checkCompanyUsersFaliure());
  }
}

function* chargeRequestExtern({
  payload,
  meta,
}: ReturnType<typeof CompanyUsersActions.chargeRequestExternRequest>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Fazendo Pedidos...' }));

    const formData = new FormData();
    formData.append('attachment', payload.formData[0]);

    yield put(DialogsActions.setOpenLoading({ title: 'Aguarde..' }));

    const response = yield call(companyUsersApi.chargeRequestExtern, {
      formData,
      transportOperator: ENVIRONMENTS.OPERATOR_ID || '',
    });

    if (response.status === 200) {
      yield put(CompanyUsersActions.chargeRequestExternSuccess());
      yield put(DialogsActions.setClose());
    }
    yield meta.promise.resolve(response);
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('company Users - chargeRequestExtern - error', error);
    if (
      !COMPANNIES.ERROR_CODE.some(
        (item) => item.KEY === error.response?.data?.internalCode,
      )
    ) {
      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'error',
          message,
        }),
      );
    }
    yield put(CompanyUsersActions.chargeRequestExternFailure());
    yield put(DialogsActions.setClose());
    yield meta.promise.resolve(error.response);
  }
}

function* list({
  payload,
}: ReturnType<typeof CompanyUsersActions.listCompanyUsersRequest>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Carregando empresas' }));
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );
    const response = yield call(companyUsersApi.list, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        CompanyUsersActions.listCompanyUsersSuccess({
          companyUsersList: response.data,
          totalCount: parseInt(response.headers.totalcount, 10),
        }),
      );
      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('company Users - listCompanies - error', error);
    yield put(
      SnackbarsActions.setOpen({
        message,
        open: true,
        type: 'error',
      }),
    );
    yield put(CompanyUsersActions.listCompanyUsersFaliure());
    yield put(DialogsActions.setClose());
  }
}

function* create({
  payload,
}: ReturnType<typeof CompanyUsersActions.createCompanyUsersRequest>): any {
  try {
    const { body, redirectTo } = payload;

    yield put(DialogsActions.setOpenLoading({ title: 'Criando empresa' }));

    const response = yield call(companyUsersApi.create, { data: { ...body } });

    if (response.status === 200) {
      yield put(DialogsActions.setClose());

      yield put(
        CompanyUsersActions.createCompanyUsersSuccess({
          companyUsersData: response.data,
        }),
      );
      if (redirectTo) yield put(push(redirectTo));
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('company Users - createCompany - error', error);
    yield put(
      SnackbarsActions.setOpen({
        message,
        open: true,
        type: 'error',
      }),
    );
    yield put(CompanyUsersActions.createCompanyUsersFailure());
    yield put(DialogsActions.setClose());
  }
}

function* update({
  payload,
}: ReturnType<typeof CompanyUsersActions.updateCompanyUsersRequest>): any {
  try {
    const { body, redirectTo } = payload;
    yield put(DialogsActions.setOpenLoading({ title: 'Editando dados' }));
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );
    const response = yield call(companyUsersApi.update, {
      data: { transportOperatorId: transportOperator.id, ...body },
    });

    if (response.status === 200) {
      yield put(
        CompanyUsersActions.updateCompanyUsersSuccess({
          companyUsersData: response.data,
        }),
      );
      yield put(DialogsActions.setClose());
      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'success',
          message: 'Empresa alterada com sucesso',
        }),
      );
      if (redirectTo) yield put(push(redirectTo));
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('company Users - updateCompany - error', error);
    yield put(
      SnackbarsActions.setOpen({
        message,
        open: true,
        type: 'error',
      }),
    );
    yield put(CompanyUsersActions.updateCompanyUsersFailure());
    yield put(DialogsActions.setClose());
  }
}

function* remove({
  payload,
}: ReturnType<typeof CompanyUsersActions.deleteCompanyUsersRequest>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Excluindo empresa' }));
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );
    const response = yield call(companyUsersApi.delete, {
      data: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(CompanyUsersActions.deleteCompanyUsersSuccess());
      yield put(DialogsActions.setClose());
      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'success',
          message: 'Empresa excluída com sucesso',
        }),
      );
      yield put(CompanyUsersActions.listCompanyUsersRequest({}));
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('company Users - deleteCompany - error', error);
    yield put(
      SnackbarsActions.setOpen({
        message,
        open: true,
        type: 'error',
      }),
    );
    yield put(CompanyUsersActions.deleteCompanyUsersFailure());
    yield put(DialogsActions.setClose());
  }
}

function* removeUser({
  payload,
}: ReturnType<typeof CompanyUsersActions.deleteCompanyUserRequest>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Excluindo empresa' }));
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );
    const response = yield call(companyUsersApi.deleteUser, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(CompanyUsersActions.deleteCompanyUserSuccess());
      yield put(DialogsActions.setClose());
      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'success',
          message: 'Empresa excluída com sucesso',
        }),
      );
      yield put(CompanyUsersActions.listCompanyUsersRequest({}));
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('company User - deleteCompany - error', error);
    yield put(
      SnackbarsActions.setOpen({
        message,
        open: true,
        type: 'error',
      }),
    );
    yield put(CompanyUsersActions.deleteCompanyUserFailure());
    yield put(DialogsActions.setClose());
  }
}

// eslint-disable-next-line import/prefer-default-export
export const companyUsersSagas = [
  takeLatest(CompanyUsersTypes.CHECK_COMPANY_USERS_REQUEST, check),
  takeLatest(
    CompanyUsersTypes.CHARGE_REQUEST_EXTERNAL_REQUEST,
    chargeRequestExtern,
  ),
  takeLatest(CompanyUsersTypes.LIST_COMPANY_USERS_REQUEST, list),
  takeLatest(CompanyUsersTypes.CREATE_COMPANY_USERS_REQUEST, create),
  takeLatest(CompanyUsersTypes.UPDATE_COMPANY_USERS_REQUEST, update),
  takeLatest(CompanyUsersTypes.DELETE_COMPANY_USERS_REQUEST, remove),
  takeLatest(CompanyUsersTypes.DELETE_COMPANY_USER_REQUEST, removeUser),
];
